var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuchungenOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.18 24.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6611;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.64,5.98l10.49,5.65,10.55-5.57c.07-.03,.07-.13,0-.17L12.27,.33c-.74-.44-1.66-.44-2.4,0L.64,5.81c-.06,.04-.06,.13,0,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.12,6.9l10.5,5.59v12.28c0,.06-.07,.1-.12,.07L1.21,19.55c-.75-.43-1.21-1.22-1.21-2.09V6.97c0-.06,.07-.1,.12-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.06,6.9l-10.5,5.59v12.28c0,.06,.07,.1,.12,.07l9.28-5.29c.75-.43,1.21-1.22,1.21-2.09V6.97c0-.06-.07-.1-.12-.07Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuchungenOrange);
export default __webpack_public_path__ + "static/media/Buchungen_orange.6e274d1f776b689e3fc72d5bd00dc052.svg";
export { ForwardRef as ReactComponent };